"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMap = exports.useQueryResource = exports.useMultipleQueryResource = exports._useQueryResource = exports.getListFromMultipleQueries = exports.useDocResource = void 0;
const firestore_1 = require("firebase/firestore");
const react_smart_hook_firebase_1 = require("@smart-hook/react-smart-hook-firebase");
const react_hook_retention_cache_1 = require("@smart-hook/react-hook-retention-cache");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const firestore_web_1 = require("comodel/firestore-web");
const hooks_1 = require("common/hooks");
const mingo_1 = require("mingo");
const react_1 = require("react");
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const useDocumentData = (0, react_smart_hook_firebase_1.createDocumentRefHook)();
const useDocResource = (resourcePath, id) => {
    return useDocumentData(id
        ? (0, firestore_1.doc)(firestore, `${resourcePath}/${id}`)
        : undefined);
};
exports.useDocResource = useDocResource;
const optionConverter = (titleKey, filter) => {
    const mingoFilter = filter ? new mingo_1.Query(filter) : undefined;
    return {
        toFirestore: (d) => d,
        fromFirestore: (snapshot) => {
            const data = snapshot.data();
            return {
                title: (0, hooks_1.resolveStringIntl)(data[titleKey]) || "",
                value: snapshot.id,
                disabled: mingoFilter ? !mingoFilter.test(data) : false,
            };
        },
    };
};
const queryCache = (0, react_smart_hook_firebase_1.getQueryCache)(({ resourcePath, titleKey, query: _query, filter, }) => {
    return (0, firestore_1.query)((0, firestore_1.collection)(firestore, resourcePath), ...(0, firestore_web_1.getQueryConstraints)(_query || {})).withConverter(optionConverter(titleKey, filter));
}, { withData: true, retentionTime: 1000 });
function resolveObject(request, converter) {
    return __awaiter(this, void 0, void 0, function* () {
        const entries = Object.entries(request);
        const resolvedEntries = yield Promise.all(entries.map((_a) => __awaiter(this, [_a], void 0, function* ([key, value]) { return [key, yield converter(value)]; })));
        return Object.fromEntries(resolvedEntries);
    });
}
const getListFromMultipleQueries = (resourceRequests) => __awaiter(void 0, void 0, void 0, function* () {
    const resolve = resolveObject(resourceRequests, (value) => {
        const { resourcePath, titleKey, filter } = value;
        const snapShot = (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, resourcePath), ...(0, firestore_web_1.getQueryConstraints)({ filter })).withConverter(optionConverter(titleKey)));
        return snapShot.then((snapShot) => {
            const list = snapShot.docs.map((doc) => doc.data());
            return { list };
        });
    });
    return resolve;
});
exports.getListFromMultipleQueries = getListFromMultipleQueries;
exports._useQueryResource = (0, react_hook_retention_cache_1.createStoreCacheHook)(queryCache, {});
exports.useMultipleQueryResource = (0, react_hook_retention_cache_1.createMultipleStoreCacheHook)(queryCache, {});
const useQueryResource = (params) => {
    const result = (0, exports._useQueryResource)(params);
    const list = (0, react_1.useMemo)(() => { var _a; return (_a = result === null || result === void 0 ? void 0 : result.list) === null || _a === void 0 ? void 0 : _a.filter((item) => !item.disabled); }, [result === null || result === void 0 ? void 0 : result.list]);
    return Object.assign(Object.assign({}, result), { list });
};
exports.useQueryResource = useQueryResource;
const cache = new WeakMap();
const toMap = (list) => {
    if (!cache.has(list)) {
        cache.set(list, new Map(list.map((item) => [item.value, item.title])));
    }
    return cache.get(list);
};
exports.toMap = toMap;
